export default __webpack_public_path__ + "static/media/image-4.565e6ee3.png";